import React from "react";
import moment from "moment";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { getTime } from "../../function/group";

const Comment = ({ item, handleDeleteModal }) => {
  const user = useSelector((state) => state?.user?.data[0]);

  return (
    <li key={item.feedRecommentNo}>
      <img src={item.mberImgPath ? imgHandler(item.mberImgPath) : "/img/user2.png"} />
      <div>
        <span>{item.nickNm ? item.nickNm : "닉네임 미설정"}</span>
        <p>{item.content}</p>
      </div>
      {user && item.mberNo === user.mberNo && (
        <button onClick={() => handleDeleteModal(item, "comment")} className="delete">
          <AiOutlineClose />
        </button>
      )}
      <div className="date">{getTime(item.createDt)}</div>
    </li>
  );
};

export default Comment;
